import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { useParams, useHistory } from "react-router-dom";
import { calcularTotales } from "./utils/calcularTotales";
import { generarProfesionalesPorLiquidacion } from "./utils/generarProfesionalesData";
import LiquidacionesAsociadas from "./components/LiquidacionesAsociadas";
import Profesionales from "./components/Profesionales";
import Proveedores from "./components/Proveedores";
import Anticipos from "../liquidacion/Anticipos";
import { getPagoProveedoresByOrdenDePago, UpdateORDEN } from "../../../api/ordenesDePagoApi";
import { getAnticiposByOrdenDePago } from "../../../api/anticiposApi";
import { Modal, Button, Form } from "react-bootstrap";
import { addPagoProveedor, getAllProveedores } from "../../../api/proveedorApi";
// APIs
import { getUserCredentials } from "../../../api/usuarioApi";
import { getAdminById } from "../../../api/AdminApi";
import Dropdown from "react-bootstrap/Dropdown"; // ✅ agregar al inicio
import {
  getOrdenDePagoById,
  getLiquidacionByOrdenDePago,
  cambiarEstadoLiq,
  addLiquidacionToOrden,
  removeLiquidacionFromOrden,
} from "../../../api/ordenesDePagoApi";
import {
  getgastosbyliquidacion,
  getasistenciasbyliquidacion,
  getlegajosbyliquidacion,
} from "../../../api/marcacionApi";
import Select from "react-select";
import { formatMiles } from "../../../utils/miles"; // ✅ agregado para formatear totales
import Swal from "sweetalert2";
import { canAccess } from "../../../utils/permissions";

function FichaOrden() {
  const { id: routeId } = useParams();
  const history = useHistory();

  const [proveedores, setProveedores] = useState([]);
  const [anticipos, setAnticipos] = useState([]);
  const [listaProveedores, setListaProveedores] = useState([]); // ✅ NUEVO
  const [showModalAgregarLiq, setShowModalAgregarLiq] = useState(false);
  const [showModalQuitarLiq, setShowModalQuitarLiq] = useState(false);
  const [showModalCierreLiq, setShowModalCierreLiq] = useState(false);
  const [codigoAgregar, setCodigoAgregar] = useState("");
  const [codigoQuitar, setCodigoQuitar] = useState("");
  const [codigoCierre, setCodigoCierre] = useState("");
  const [idAgregarLiq, setIdAgregarLiq] = useState("");
  const [idQuitarLiq, setIdQuitarLiq] = useState("");
  const [idCierreLiq, setIdCierreLiq] = useState("");
  const [activeTab, setActiveTab] = useState("liquidaciones");

  const [loadingInicial, setLoadingInicial] = useState(true);
  const [loadingDetalles, setLoadingDetalles] = useState(false);
  const [hasPermission, setHasPermission] = useState(null);

  const [orden, setOrden] = useState(null);
  const [liquidaciones, setLiquidaciones] = useState([]);

  const [liqDetalles, setLiqDetalles] = useState({});
  const [profesionalesData, setProfesionalesData] = useState([]);

  const [error, setError] = useState(null);

  const detailsCacheRef = useRef({});
  const fetchedAllRef = useRef(false);

  const [showModalProveedor, setShowModalProveedor] = useState(false);
  const [nuevoProveedor, setNuevoProveedor] = useState({
    // ✅ extendido con la nueva estructura
    idProveedor: "",
    proveedor: "",
    ruc: "",
    razonsocial: "",
    factura: "",
    monto: "",
    fechaorden: "",
    estado: "PENDIENTE",
    idordendepago: "",
  });
  const [savingProveedor, setSavingProveedor] = useState(false);

  // Modal estado
  const [showModal, setShowModal] = useState(false);
  const [nuevoEstado, setNuevoEstado] = useState("");
  const [updatingEstado, setUpdatingEstado] = useState(false);

  // Cálculo de resumen (sumas honorarios y tarifa)
  const resumenTotales = useMemo(() => {
    let honorarios = 0;
    let tarifa = 0;
    for (const tot of Object.values(liqDetalles)) {
      if (!tot) continue;
      if (typeof tot.honorarios === "number") honorarios += tot.honorarios;
      if (typeof tot.tarifa === "number") tarifa += tot.tarifa;
    }
    // sumar proveedores a honorarios
    for (const p of proveedores) {
      if (typeof p.monto === "number") honorarios += p.monto;
    }
    const totalAnticipos = anticipos.reduce((acc, item) => acc + (Number(item.monto) || 0), 0);
    honorarios -= totalAnticipos;
    return { honorarios, tarifa, anticipos: totalAnticipos };
  }, [liqDetalles, proveedores, anticipos]);

  // ---------------- Permisos + Orden + Liquidaciones + Lista Proveedores ----------------
  const init = useCallback(async () => {
    setLoadingInicial(true);
    setError(null);
    try {
      const resultUser = await getUserCredentials();
      const USERDATA = await getAdminById(resultUser.IdUsuario);

      if (!USERDATA || !canAccess(USERDATA[0], "ordenPago")) {
        setHasPermission(false);
        return;
      }
      setHasPermission(true);

      // --- Orden ---
      try {
        const ordenData = await getOrdenDePagoById(routeId);
        setOrden(ordenData?.orden || null);
        if (ordenData?.orden?.fechainicio) {
          setNuevoProveedor((prev) => ({
            ...prev,
            fechaorden: ordenData.orden.fechainicio, // ✅ inicializa con fecha de inicio
          }));
        }
      } catch (err) {
        console.error("Error cargando orden:", err);
        setOrden(null); // 👈 igual seteo
      }

      // --- Liquidaciones ---
      try {
        const liqData = await getLiquidacionByOrdenDePago(routeId);
        const list = Array.isArray(liqData) ? liqData : [];
        setLiquidaciones(list);
      } catch (err) {
        console.error("Error cargando liquidaciones:", err);
        setLiquidaciones([]); // 👈 igual seteo
      }

      // --- Proveedores (pagos de esta orden) ---
      try {
        const provData = await getPagoProveedoresByOrdenDePago(routeId);
        setProveedores(Array.isArray(provData) ? provData : []);
      } catch (err) {
        console.error("Error cargando proveedores:", err);
        setProveedores([]); // 👈 igual seteo
      }

      // --- Anticipos (descuentos de esta orden) ---
      try {
        const antData = await getAnticiposByOrdenDePago(routeId);
        setAnticipos(Array.isArray(antData) ? antData : []);
      } catch (err) {
        console.error("Error cargando anticipos:", err);
        setAnticipos([]);
      }

      // --- Lista completa de proveedores (catálogo contabilidad) ✅ NUEVO
      try {
        const lista = await getAllProveedores();
        setListaProveedores(Array.isArray(lista) ? lista : []);
      } catch (err) {
        console.error("Error cargando lista de proveedores:", err);
        setListaProveedores([]);
      }
    } catch (e) {
      console.error("Error global init:", e);
      setHasPermission(false);
      setError("Error de permisos o credenciales.");
    } finally {
      setLoadingInicial(false);
    }
  }, [routeId]);

  useEffect(() => {
    init();
  }, [init]);

  // ---------------- Actualizar estado ----------------
  const handleGuardarEstado = async () => {
    if (!orden?.idordendepago || !nuevoEstado) return;
    setUpdatingEstado(true);
    try {
      await UpdateORDEN(orden.idordendepago, nuevoEstado); // 👈 enviar "EN PROCESO"
      setOrden((prev) => ({ ...prev, estado: nuevoEstado })); // 👈 guardar igual
      setShowModal(false);
    } catch (e) {
      console.error("Error al actualizar estado", e);
    } finally {
      setUpdatingEstado(false);
    }
  };


  const handleAgregarLiquidacion = async () => {
    if (!idAgregarLiq) return Swal.fire("ID requerido", "Ingrese un ID de liquidación válido.", "warning");
    if (codigoAgregar.length !== 6)
      return Swal.fire("OTP requerido", "Ingrese un código de autorización de 6 dígitos.", "warning");
    try {
      await addLiquidacionToOrden(idAgregarLiq,routeId,codigoAgregar);
      await Swal.fire({
        icon: "success",
        title: "Liquidación agregada",
        text: `La liquidación ${idAgregarLiq} fue agregada a la orden correctamente.`,
        timer: 1800,
        showConfirmButton: false,
      });
      setShowModalAgregarLiq(false);
      setIdAgregarLiq("");
      setCodigoAgregar("");
      init();
    } catch (err) {
      console.error(err);
      Swal.fire("Error al agregar", err.message || "No se pudo agregar la liquidación con el OTP ingresado.", "error");
    }
  };

  const handleQuitarLiquidacion = async () => {
    if (!idQuitarLiq) return Swal.fire("ID requerido", "Ingrese un ID de liquidación válido.", "warning");
    if (codigoQuitar.length !== 6)
      return Swal.fire("OTP requerido", "Ingrese un código de autorización de 6 dígitos.", "warning");
    try {
      await removeLiquidacionFromOrden(idQuitarLiq,codigoQuitar);
      await Swal.fire({
        icon: "success",
        title: "Liquidación quitada",
        text: `La liquidación ${idQuitarLiq} fue quitada correctamente.`,
        timer: 1800,
        showConfirmButton: false,
      });
      setShowModalQuitarLiq(false);
      setIdQuitarLiq("");
      setCodigoQuitar("");
      init();
    } catch (err) {
      console.error(err);
      Swal.fire("Error al quitar", err.message || "No se pudo quitar la liquidación con el OTP ingresado.", "error");
    }
  };

  const handleCambiarACierre = async () => {
    if (!idCierreLiq) return Swal.fire("ID requerido", "Ingrese un ID de liquidación válido.", "warning");
    if (codigoCierre.length !== 6)
      return Swal.fire("OTP requerido", "Ingrese un código de autorización de 6 dígitos.", "warning");
    try {
      

      await cambiarEstadoLiq(idCierreLiq,codigoCierre);
      await Swal.fire({
        icon: "success",
        title: "Estado actualizado",
        text: `La liquidación ${idCierreLiq} fue cambiada a cierre correctamente.`,
        timer: 1800,
        showConfirmButton: false,
      });
      setShowModalCierreLiq(false);
      setIdCierreLiq("");
      setCodigoCierre("");
      init();
    } catch (err) {
      console.error(err);
      Swal.fire("Error al cambiar estado", err.message || "No se pudo cambiar a cierre con el OTP ingresado.", "error");
    }
  };

  // ---------------- Carga paralela de TODOS los detalles ----------------
  useEffect(() => {
    if (hasPermission !== true) return;
    if (liquidaciones.length === 0) {
      setLiqDetalles({});
      setProfesionalesData([]);
      return;
    }
    if (fetchedAllRef.current) return;

    let cancelado = false;
    fetchedAllRef.current = true;
    setLoadingDetalles(true);

    const buildTask = (liq) => {
      const id = liq.idLiquidacionClientes;
      if (!id) return async () => null;
      return async () => {
        try {
          const [gastos, asistencias, legajos] = await Promise.all([
            getgastosbyliquidacion(id),
            getasistenciasbyliquidacion(id),
            getlegajosbyliquidacion(id),
          ]);

          const totales = calcularTotales(gastos, asistencias, legajos);
          const profesionales = generarProfesionalesPorLiquidacion(
            asistencias,
            legajos,
            id,
            liq.NombrePaciente
          );

          return { id, gastos, asistencias, legajos, totales, profesionales };
        } catch (e) {
          console.error("Error detalles liquidación", id, e);
          return {
            id,
            gastos: [],
            asistencias: [],
            legajos: [],
            totales: null,
            profesionales: [],
            error: true,
          };
        }
      };
    };

    const tasks = liquidaciones.map(buildTask);

    (async () => {
      try {
        const results = await Promise.all(tasks.map((fn) => fn && fn()));
        if (cancelado) return;

        const cache = { ...detailsCacheRef.current };
        const liqTotalesObj = {};
        let allProfesionales = [];

        for (const r of results) {
          if (!r || !r.id) continue;
          cache[r.id] = {
            gastos: r.gastos,
            asistencias: r.asistencias,
            legajos: r.legajos,
            totales: r.totales,
            profesionales: r.profesionales,
            error: r.error,
          };
          liqTotalesObj[r.id] = r.totales;
          allProfesionales = allProfesionales.concat(r.profesionales);
        }

        detailsCacheRef.current = cache;
        setLiqDetalles(liqTotalesObj);
        setProfesionalesData(allProfesionales);
      } catch (e) {
        console.error("Error global fetchAllDetails", e);
        if (!cancelado) setError("Error al cargar detalles de las liquidaciones.");
      } finally {
        if (!cancelado) setLoadingDetalles(false);
      }
    })();

    return () => {
      cancelado = true;
    };
  }, [hasPermission, liquidaciones]);

  // ---------------- Guardar Pago Proveedor (con nueva estructura) ----------------
  const handleGuardarProveedor = async () => {
    if (!nuevoProveedor.idProveedor || !nuevoProveedor.monto) return;

    setSavingProveedor(true);
    try {
      const ok = await addPagoProveedor({
        ...nuevoProveedor,
        idordendepago: orden?.idordendepago,
      });

      if (ok) {
        // Refrescar proveedores al guardar
        const provData = await getPagoProveedoresByOrdenDePago(routeId);
        setProveedores(Array.isArray(provData) ? provData : []);
        setShowModalProveedor(false);
        setNuevoProveedor({
          idProveedor: "",
          proveedor: "",
          ruc: "",
          razonsocial: "",
          factura: "",
          monto: "",
          fechaorden: orden?.fechainicio || "",
          estado: "PENDIENTE",
        });
      }
    } catch (e) {
      console.error("Error al guardar proveedor:", e);
      alert("Hubo un error al guardar el proveedor.");
    } finally {
      setSavingProveedor(false);
    }
  };

  // ---------------- Seleccionar Proveedor (autocompleta RUC y Razón Social) ----------------
  const handleSelectProveedor = (id) => {
    const prov = listaProveedores.find((p) => p.idProveedores === Number(id));
    if (prov) {
      setNuevoProveedor((prev) => ({
        ...prev,
        idProveedor: prov.idProveedores,
        proveedor: prov.proveedor,
        ruc: prov.ruc || "",
        razonsocial: prov.razonsocial || "",
      }));
    } else {
      setNuevoProveedor((prev) => ({
        ...prev,
        idProveedor: "",
        proveedor: "",
        ruc: "",
        razonsocial: "",
      }));
    }
  };

  // ---------------- Render ----------------
  if (loadingInicial) {
    return (
      <div
        style={{
          minHeight: "60vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          zIndex: 2,
        }}
      >
        <div
          style={{
            width: 38,
            height: 38,
            border: "4px solid #ddd",
            borderTop: "4px solid #1569c9ff",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        />
        <span style={{ marginLeft: 14, color: "#444", fontSize: 18 }}>
          Cargando...
        </span>
        <style>
          {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
        </style>
      </div>
    );
  }
  if (hasPermission === false) {
    return (
      <div className="container py-5 text-center">
        <h4 className="text-danger mb-3">
          No tiene permisos para ver esta información.
        </h4>
      </div>
    );
  }
  if (hasPermission !== true) return null;

  if (error) {
    return (
      <div className="container py-4">
        <div className="alert alert-danger mb-0">{error}</div>
      </div>
    );
  }

  const loadingGlobal = loadingDetalles && !Object.keys(liqDetalles).length;

  return (
    <div className="container-fluid" style={{ maxWidth: "96%" }}>
      <div className="row">
        <div className="col-12">
          <div className="card mb-3 shadow-sm">
            <div className="card-header d-flex flex-wrap justify-content-between align-items-center">
              <h3 className="mb-0">
                Orden de Pago
                <small className="d-block mt-1 text-muted">
                  Ficha Orden #{routeId}
                </small>
                {orden?.idordendepago && (
                  <div className="mt-2">
                    <span
                      className="badge bg-light text-dark border"
                      style={{
                        fontWeight: "600",
                        fontSize: 13,
                        padding: "6px 12px",
                        letterSpacing: 0.5,
                      }}
                    >
                      ID: {orden.idordendepago}
                    </span>
                  </div>
                )}
              </h3>

              <div className="mt-3 mt-sm-0 d-flex align-items-center">
           
                <div className="mt-3 mt-sm-0 d-flex align-items-center">
                  <span
                    className={`badge rounded-pill ${orden?.estado === "CERRADO"
                      ? "bg-success"
                      : orden?.estado === "PENDIENTE"
                        ? "bg-warning text-dark"
                        : "bg-primary"
                      }`}
                    style={{ fontSize: 13, padding: "8px 14px" }}
                  >
                    {orden?.estado || "SIN ESTADO"}
                  </span>

                  <Dropdown className="ms-3">
                    <Dropdown.Toggle
                      variant="outline-primary"
                      size="sm"
                      id="dropdown-actions"
                    >
                      Acciones
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => setShowModalProveedor(true)}>
                        ➕ Agregar Pago Proveedor
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setShowModalAgregarLiq(true)}>
                        🧾 Agregar Liquidación
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setShowModalQuitarLiq(true)}>
                        ❌ Quitar Liquidación
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setShowModalCierreLiq(true)}>
                        🔁 Cambiar a Cierre (Liq)
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item
                        onClick={() => {
                          if (orden?.estado === "CREADO") {
                            setNuevoEstado("EN PROCESO");
                          } else {
                            setNuevoEstado(orden?.estado || "EN PROCESO");
                          }
                          setShowModal(true);
                        }}
                      >
                        ⚙️ Cambiar Estado
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            <div className="card-body pt-3">
              {orden ? (
                <div className="row g-3">
                  {/* Periodo */}
                  <div className="col-sm-6 col-lg-4 col-xl-3">
                    <div className="border rounded h-100 p-3">
                      <h6 className="text-muted text-uppercase fw-bold small mb-2">
                        Periodo
                      </h6>
                      <div className="d-flex justify-content-between small py-1 border-bottom">
                        <span className="text-muted">Inicio</span>
                        <span className="fw-semibold">
                          {orden.fechainicio || "-"}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between small py-1 border-bottom">
                        <span className="text-muted">Fin</span>
                        <span className="fw-semibold">
                          {orden.fechafin || "-"}
                        </span>
                      </div>
                      <div className="mt-3">
                        <div className="small text-muted mb-1">Descripción</div>
                        <div
                          className="small border rounded p-2 bg-light"
                          style={{ minHeight: 60 }}
                        >
                          {orden.descripcion || (
                            <span className="text-muted">Sin descripción</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Estado / Usuario */}
                  <div className="col-sm-6 col-lg-4 col-xl-3">
                    <div className="border rounded h-100 p-3">
                      <h6 className="text-muted text-uppercase fw-bold small mb-2">
                        Estado / Usuario
                      </h6>
                      <div className="d-flex justify-content-between small py-1 border-bottom">
                        <span className="text-muted">Estado</span>
                        <span className="fw-semibold">
                          {orden.estado || "-"}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between small py-1 border-bottom">
                        <span className="text-muted">Creado por</span>
                        <span className="fw-semibold">
                          {orden.usuariocreacion || "-"}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between small py-1 border-bottom">
                        <span className="text-muted">Fecha Creación</span>
                        <span className="fw-semibold">
                          {orden.fechacreacion || "-"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Resumen */}
                  <div className="col-sm-6 col-lg-4 col-xl-3">
                    <div className="border rounded h-100 p-3">
                      <h6 className="text-muted text-uppercase fw-bold small mb-2">
                        Resumen
                      </h6>
                      <div className="d-flex justify-content-between small py-1 border-bottom text-primary">
                        <span>Honorarios Totales</span>
                        <span className="fw-semibold">
                          {loadingDetalles && !Object.keys(liqDetalles).length
                            ? "..."
                            : formatMiles(resumenTotales.honorarios)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between small py-1 text-success border-bottom">
                        <span>Proveedores</span>
                        <span className="fw-semibold">
                          {formatMiles(proveedores.reduce((a, p) => a + (p.monto || 0), 0))}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between small py-1 text-danger border-bottom">
                        <span>Anticipos</span>
                        <span className="fw-semibold">
                          -{formatMiles(resumenTotales.anticipos)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between small py-1 text-warning">
                        <span>Tarifa Total</span>
                        <span className="fw-semibold">
                          {loadingDetalles && !Object.keys(liqDetalles).length
                            ? "..."
                            : formatMiles(resumenTotales.tarifa)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="alert alert-warning mb-0">
                  No se encontró la orden solicitada.
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="col-12">
          <div className="card shadow-sm mb-4">
            <div className="card-header pb-0">
              <ul className="nav nav-tabs card-header-tabs flex-nowrap overflow-auto">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === "liquidaciones" ? "active" : ""}`}
                    onClick={() => setActiveTab("liquidaciones")}
                    type="button"
                  >
                    Liquidaciones Asociadas
                    {loadingDetalles && activeTab === "liquidaciones" && (
                      <span className="spinner-border spinner-border-sm ms-2" />
                    )}
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === "profesionales" ? "active" : ""}`}
                    onClick={() => setActiveTab("profesionales")}
                    type="button"
                  >
                    Profesionales
                    {loadingDetalles && activeTab === "profesionales" && (
                      <span className="spinner-border spinner-border-sm ms-2" />
                    )}
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === "anticipos" ? "active" : ""}`}
                    onClick={() => setActiveTab("anticipos")}
                    type="button"
                  >
                    Anticipos
                  </button>
                </li>
              </ul>
            </div>

            <div className="card-body">
              {loadingGlobal && (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary mb-2" />
                  <div className="small text-muted">
                    Preparando detalles de liquidaciones...
                  </div>
                </div>
              )}

              {!loadingGlobal && activeTab === "liquidaciones" && (
                <LiquidacionesAsociadas
                  liquidaciones={liquidaciones}
                  liqDetalles={liqDetalles}
                  proveedores={proveedores}
                  anticipos={anticipos}
                  loadingDetalles={loadingDetalles}
                  orden={orden}
                />
              )}

              {!loadingGlobal && activeTab === "profesionales" && (
                <div className="animate-fade">
                  <div className="row g-3">
                    <div className="col-12">
                      <div className="card border-0 shadow-sm">
                        <div className="card-body p-2">
                          <Profesionales
                            profesionalesData={profesionalesData}
                            idordendepago={routeId}
                            fechainicio={orden.fechainicio}
                            fechafin={orden.fechafin}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="card border-0 shadow-sm">
                        <div className="card-body p-2">
                          <Proveedores
                            idOrdenDePago={routeId}
                            idordendepago={routeId}
                            fechainicio={orden.fechainicio}
                            fechafin={orden.fechafin}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {!loadingGlobal && activeTab === "anticipos" && (
                <div className="animate-fade">
                  <Anticipos
                    idordendepago={routeId}
                    onChange={setAnticipos}
                  />
                </div>
              )}

              {!loadingGlobal &&
                activeTab !== "liquidaciones" &&
                activeTab !== "profesionales" &&
                activeTab !== "anticipos" && (
                  <div className="text-muted small">
                    Seleccione una pestaña para ver información.
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal para cambiar estado */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Actualizar Estado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-around">
            <Form.Check
              type="radio"
              label="Creado"
              checked={orden?.estado === "CREADO"}
              disabled
            />
            <Form.Check
              type="radio"
              label="En Proceso"
              value="EN PROCESO"
              checked={nuevoEstado === "EN PROCESO"}
              disabled={orden?.estado !== "CREADO"}
              onChange={(e) => setNuevoEstado(e.target.value)}
            />
            <Form.Check
              type="radio"
              label="Finalizado"
              value="FINALIZADO"
              checked={nuevoEstado === "FINALIZADO"}
              disabled={orden?.estado === "FINALIZADO" || orden?.estado === "CREADO"}
              onChange={(e) => setNuevoEstado(e.target.value)}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleGuardarEstado}
            disabled={updatingEstado}
          >
            {updatingEstado ? "Guardando..." : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Agregar Proveedor (con select y autocompletar RUC/Razón Social) */}
      <Modal show={showModalProveedor} onHide={() => setShowModalProveedor(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Proveedor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* ✅ Select de proveedor (sin cambiar estilos) */}
            <Form.Group className="mb-3">
              <Form.Label>Proveedor <span className="text-danger">*</span></Form.Label>
              <Select
                options={listaProveedores.map((prov) => ({
                  value: prov.idProveedores,
                  label: prov.proveedor,
                }))}
                placeholder="Seleccione un proveedor..."
                value={
                  listaProveedores.find((opt) => opt.value === nuevoProveedor.idProveedor) ||
                  null
                }
                onChange={(selected) => {
                  if (selected) {
                    handleSelectProveedor(selected.value);
                  } else {
                    setNuevoProveedor({
                      idProveedor: "",
                      proveedor: "",
                      ruc: "",
                      razonsocial: "",
                    });
                  }
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? "#0d6efd" : "#ced4da",
                    boxShadow: state.isFocused
                      ? "0 0 0 0.15rem rgba(13,110,253,.25)"
                      : "none",
                    borderRadius: "0.375rem",
                    minHeight: "38px",
                  }),
                }}
                isClearable
              />
            </Form.Group>

            {/* Campos autocompletados */}
            <Form.Group className="mb-3">
              <Form.Label>RUC</Form.Label>
              <Form.Control
                type="text"
                value={nuevoProveedor.ruc}
                disabled
                placeholder="RUC del proveedor"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Razón Social</Form.Label>
              <Form.Control
                type="text"
                value={nuevoProveedor.razonsocial}
                disabled
                placeholder="Razón social del proveedor"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Factura</Form.Label>
              <Form.Control
                type="text"
                value={nuevoProveedor.factura}
                onChange={(e) => setNuevoProveedor({ ...nuevoProveedor, factura: e.target.value })}
                placeholder="N° de factura"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Monto</Form.Label>
              <Form.Control
                type="text"
                value={nuevoProveedor.monto ? formatMiles(nuevoProveedor.monto) : ""}
                onChange={(e) => {
                  const raw = e.target.value.replace(/\./g, ""); // quitar separadores de miles
                  setNuevoProveedor({
                    ...nuevoProveedor,
                    monto: raw ? parseFloat(raw) : "",
                  });
                }}
                placeholder="Monto"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Fecha </Form.Label>
              <Form.Control
                type="date"
                value={nuevoProveedor.fechaorden}
                onChange={(e) => setNuevoProveedor({ ...nuevoProveedor, fechaorden: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowModalProveedor(false)}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleGuardarProveedor} disabled={savingProveedor}>
            {savingProveedor ? "Guardando..." : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal Agregar Liquidación */}
      <Modal show={showModalAgregarLiq} onHide={() => setShowModalAgregarLiq(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Liquidación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>ID de Liquidación</Form.Label>
            <Form.Control
              type="number"
              placeholder="Ingrese el ID de la liquidación"
              value={idAgregarLiq}
              onChange={(e) => setIdAgregarLiq(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Código de Autorización (6 dígitos)</Form.Label>
            <Form.Control
              type="password"
              placeholder="******"
              maxLength={6}
              value={codigoAgregar}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, ""); // solo números
                setCodigoAgregar(val);
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowModalAgregarLiq(false)}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleAgregarLiquidacion}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Quitar Liquidación */}
      <Modal show={showModalQuitarLiq} onHide={() => setShowModalQuitarLiq(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Quitar Liquidación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>ID de Liquidación</Form.Label>
            <Form.Control
              type="number"
              placeholder="Ingrese el ID de la liquidación a quitar"
              value={idQuitarLiq}
              onChange={(e) => setIdQuitarLiq(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Código de Autorización (6 dígitos)</Form.Label>
            <Form.Control
              type="password"
              placeholder="******"
              maxLength={6}
              value={codigoQuitar}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, "");
                setCodigoQuitar(val);
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowModalQuitarLiq(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleQuitarLiquidacion}>
            Quitar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Cambiar a Cierre (Liq) */}
      <Modal show={showModalCierreLiq} onHide={() => setShowModalCierreLiq(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cambiar a Cierre (Liq)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>ID de Liquidación</Form.Label>
            <Form.Control
              type="number"
              placeholder="Ingrese el ID de liquidación a cerrar"
              value={idCierreLiq}
              onChange={(e) => setIdCierreLiq(e.target.value)}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Código de Autorización (6 dígitos)</Form.Label>
            <Form.Control
              type="password"
              placeholder="******"
              maxLength={6}
              value={codigoCierre}
              onChange={(e) => {
                const val = e.target.value.replace(/\D/g, "");
                setCodigoCierre(val);
              }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowModalCierreLiq(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleCambiarACierre}>
            Cambiar
          </Button>
        </Modal.Footer>
      </Modal>

      <style>
        {`
          .animate-fade {
            animation: fadein .25s ease;
          }
          @keyframes fadein {
            from { opacity: 0; transform: translateY(4px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .nav-tabs .nav-link {
            white-space: nowrap;
          }
        `}
      </style>
    </div>
  );
}

export default FichaOrden;
